module.exports = __webpack_public_path__ + "img/img1.46d944f3.jpg";